import { makeAutoObservable } from 'mobx';
import Message from './Message';

class MessageStore {
  showMessage = false;

  messages = [];

  showAlert = false;

  alerts = [];

  constructor() {
    makeAutoObservable(this);
  }

  populateMessages = () => {
    this.messages = this.messages.map((message) => new Message(message));
    if (this.messages.length > 0) {
      this.showMessage = true;
    }
  };

  populateAlerts = () => {
    this.alerts = this.messages.map((message) => new Message(message));
    if (this.alerts.length > 0) {
      this.showAlert = true;
    }
  };

  disableMessage = () => {
    this.showMessage = false;
  };

  setMessages = (message, messageType) => {
    this.messages = [];
    if (message !== '' && messageType !== '') {
      const messages = [];
      const messageObj = new Message();
      messageObj.message = message;
      messageObj.messageType = messageType;
      messages.push(messageObj);
      this.messages = messages;
    }
  };
}

export default new MessageStore();
